import React from 'react';
import { Moon, Sparkles, Star, Eye } from 'lucide-react';
export function SocialProof() {
  return <section className="pt-6 pb-12 px-5 relative overflow-hidden" data-id="element-275">
      <div className="max-w-xl mx-auto relative z-10" data-id="element-276">
        <p className="text-center text-[10px] font-bold text-brand-medium-grey uppercase tracking-[0.3em] mb-12" data-id="element-277">
          Todo lo que necesitas para aprender Tarot en un solo lugar
        </p>
        <div className="grid grid-cols-2 gap-x-8 gap-y-12 text-center" data-id="element-278">
          <StatItem value="78+" label="Cartas explicadas" icon={<Eye size={24} className="text-brand-petroleum mb-3" data-id="element-280" />} data-id="element-279" />
          <StatItem value="6" label="Productos premium" icon={<Sparkles size={24} className="text-brand-petroleum mb-3" data-id="element-282" />} data-id="element-281" />
          <StatItem value="100+" label="Ejercicios y prácticas" icon={<Moon size={24} className="text-brand-petroleum mb-3" data-id="element-284" />} data-id="element-283" />
          <StatItem value="4.9/5" label="Calificación promedio" icon={<Star size={24} className="text-brand-gold-warm mb-3 fill-brand-gold-warm" data-id="element-286" />} data-id="element-285" />
        </div>

        <div className="flex flex-wrap items-center justify-center gap-x-8 gap-y-4 mt-8 pt-6 border-t border-brand-petroleum/5" data-id="element-287">
          <span className="text-xs text-brand-dark-grey font-bold uppercase tracking-widest" data-id="element-288">
            📄 100% digital (PDF)
          </span>
          <span className="text-xs text-brand-dark-grey font-bold uppercase tracking-widest" data-id="element-289">
            ⚡ Acceso inmediato
          </span>
          <p className="text-sm text-brand-medium-grey font-medium text-center w-full mt-1 leading-relaxed" data-id="element-290">
            🔮 Diseñado para principiantes que quieren aprender a interpretar el
            Tarot con claridad, intuición y confianza.
          </p>
        </div>
      </div>
    </section>;
}
function StatItem({
  value,
  label,
  icon
}: {
  value: string;
  label: string;
  icon: React.ReactNode;
}) {
  return <div className="flex flex-col items-center justify-center" data-id="element-291">
      {icon}
      <div className="text-3xl font-bold text-brand-petroleum mb-1 tracking-tight" data-id="element-292">
        {value}
      </div>
      <div className="text-[10px] text-brand-medium-grey font-semibold uppercase tracking-widest leading-tight" data-id="element-293">
        {label}
      </div>
    </div>;
}